export default __webpack_public_path__ + "static/media/umn-logo.7ec2f46f.png";